import { render } from "./InventorySummary.vue?vue&type=template&id=58e53036&scoped=true"
import script from "./InventorySummary.vue?vue&type=script&lang=js"
export * from "./InventorySummary.vue?vue&type=script&lang=js"

import "./InventorySummary.vue?vue&type=style&index=0&id=58e53036&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e53036"]])

export default __exports__